import React, { useId, useState } from 'react';
import { ChevronLeft, ChevronRight } from 'lucide-react';
import { tx } from './i18n';
import './sample-step-navigator.css';

export default function SampleStepNavigator({ steps, currentIndex, label, children }) {
  const [browsedId, setBrowsedId] = useState(null);
  const panelId = useId();
  const browsedIndex = steps.findIndex(step => step.id === browsedId);
  // Follow live progress until the reader deliberately browses a different step.
  const selectedIndex = browsedIndex === -1 ? currentIndex : browsedIndex;
  const select = index => setBrowsedId(index === currentIndex ? null : steps[index].id);

  function onKeyDown(event) {
    let index;
    if (event.key === 'ArrowLeft') index = Math.max(0, selectedIndex - 1);
    else if (event.key === 'ArrowRight') index = Math.min(steps.length - 1, selectedIndex + 1);
    else if (event.key === 'Home') index = 0;
    else if (event.key === 'End') index = steps.length - 1;
    else return;
    event.preventDefault();
    select(index);
  }

  return <section className="xo-sample-step-viewer" aria-label={label}>
    <div className="xo-sample-step-navigation" onKeyDown={onKeyDown}>
      <button className="xo-sample-step-chevron" type="button" disabled={selectedIndex === 0}
        aria-label={tx('ui.samples.previous_step')} title={tx('ui.samples.previous_step')}
        aria-controls={panelId} onClick={() => select(selectedIndex - 1)}><ChevronLeft aria-hidden="true" /></button>
      <div id={panelId} className="xo-sample-step-panel" aria-live="polite">
        {children(steps[selectedIndex], selectedIndex === currentIndex)}
      </div>
      <button className="xo-sample-step-chevron" type="button" disabled={selectedIndex === steps.length - 1}
        aria-label={tx('ui.samples.next_step')} title={tx('ui.samples.next_step')}
        aria-controls={panelId} onClick={() => select(selectedIndex + 1)}><ChevronRight aria-hidden="true" /></button>
    </div>
    <div className="xo-sample-step-position">
      <span>{tx('ui.samples.lab_progress_step', { step: selectedIndex + 1, total: steps.length })}</span>
      {selectedIndex !== currentIndex && <button className="xo-link" type="button" onClick={() => setBrowsedId(null)}>
        {tx('ui.samples.view_current_step')}
      </button>}
    </div>
  </section>;
}
